// BD-959: which currently-synced groups are about to be turned off by this save/resync.
export const getDroppedGroups = (originalGroups, selectedGroups) =>
    originalGroups.filter(
        (og) => !selectedGroups.some((sg) => sg.userGroupId === og.userGroupId)
    );
